import {
  Header,
  Paragraph
} from '@eggplant/pattern-library'

const MonitorCaseAvailabilityInfo = () =>
  <div className='grid gap-3'>
    <Header
      hasNoBottomMargin
      hasNoTopMargin
      rank={5}
    >
      Monitor config severity trend
    </Header>
    <Paragraph>
      The severity trend chart shows the status of
      each run over time, allowing you to compare
      runs and observe trends.
    </Paragraph>
  </div>

export default MonitorCaseAvailabilityInfo
